export enum ShippingStatusEnum {
  SEARCHING_CARRIER = 'SEARCHING_CARRIER',
  COLLECTION_ROUTE = 'COLLECTION_ROUTE',
  SHIPPING_ROUTE = 'SHIPPING_ROUTE',
  DELIVERED = 'DELIVERED',
  CANCELED = 'CANCELED',
}
